export const ACTIONS = {
    SET_STATE: "SET_STATE",
};
